import React, { useState } from 'react';
import { MarketingStatus } from '../../../../domain/FilterTypes';
import { marketingStatusOptions } from '../../../../domain/filterOptions';
import { useClickOutside } from '../../../hooks/useClickOutside';
import { useFilterController } from '../../../../application/useFilterController';

export const StatusDropdown = () => {
  const { filter, setMarketingStatus } = useFilterController();

  const [ open, setOpen ] = useState(false);
  const dropdownRef = useClickOutside<HTMLDivElement>(() => setOpen(false));

  const selectedOption = marketingStatusOptions.find(
    (o) => o.value === filter.marketingStatus
  );

  const onChange = (newStatus: MarketingStatus) => {
    setMarketingStatus(newStatus);
    setOpen(false);
  };

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="border rounded px-3 py-2 bg-white text-gray-800 flex items-center justify-between min-w-[120px]"
      >
        {selectedOption?.label || 'Sale Type'}
        <svg
          className="ml-2 h-4 w-4 text-gray-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.65a.75.75 0 01-1.08 0l-4.25-4.65a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {open && (
        <div className="absolute left-0 mt-2 w-48 bg-white border rounded shadow-lg z-10">
          {marketingStatusOptions.map((opt) => (
            <button
              key={opt.value}
              onClick={() => onChange(opt.value)}
              className={`block w-full text-left px-4 py-2 text-sm hover:bg-blue-400 ${
                filter.marketingStatus === opt.value ? 'bg-blue-200 font-medium' : ''
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
